export function parseBooleanParam(raw: string | null): boolean | null {
  if (!raw) return null;
  const v = raw.toLowerCase();
  if (['true', '1', 'yes'].includes(v)) return true;
  if (['false', '0', 'no'].includes(v)) return false;
  return null;
}
